import ImageHelper from "../../Helpers/ImageHelper";

const PortfolioImagesData = {
  webDesignPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  psdToHtmlPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  appDevPortfolio: [
    { img: ImageHelper.AppBanner1 },
    { img: ImageHelper.AppBanner2 },
    { img: ImageHelper.AppBanner3 },
    { img: ImageHelper.AppBanner4 },
    { img: ImageHelper.AppBanner5 },
  ],
  BrandingPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  customWebDesignPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  ecommercePortfolio: [
    { img: ImageHelper.ECommerce1 },
    { img: ImageHelper.ECommerce2 },
    { img: ImageHelper.ECommerce3 },
    { img: ImageHelper.ECommerce4 },
    { img: ImageHelper.ECommerce5 },
    { img: ImageHelper.ECommerce6 },
  ],
  hostingPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  logoDesignPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  seoPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  shopifyDevelopmentPortfolio: [
    { img: ImageHelper.ECommerce1 },
    { img: ImageHelper.ECommerce2 },
    { img: ImageHelper.ECommerce3 },
    { img: ImageHelper.ECommerce4 },
    { img: ImageHelper.ECommerce5 },
    { img: ImageHelper.ECommerce6 },
  ],
  sslCertificatePortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  videoAnimationPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  webAppDevelopmentPortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  websiteMaintancePortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  wooCommerceDevelopmentPortfolio: [
    { img: ImageHelper.ECommerce1 },
    { img: ImageHelper.ECommerce2 },
    { img: ImageHelper.ECommerce3 },
    { img: ImageHelper.ECommerce4 },
    { img: ImageHelper.ECommerce5 },
    { img: ImageHelper.ECommerce6 },
  ],
  wordpressWebsitePortfolio: [
    { img: ImageHelper.WebBanner1 },
    { img: ImageHelper.WebBanner2 },
    { img: ImageHelper.WebBanner3 },
    { img: ImageHelper.WebBanner4 },
  ],
  uiUxDesignPortfolio: [
    { img: ImageHelper.BidroidOldUI },
    { img: ImageHelper.BidroidNewUI },
    { img: ImageHelper.CricBuzzUI },
    { img: ImageHelper.SoyHill1 },
  ],
  adsDesignPortfolio: [
    { img: ImageHelper.CricBuzzBanner },
    { img: ImageHelper.FDVsRealEstate },
    { img: ImageHelper.MindBrowserInfographic },
    { img: ImageHelper.NaazClassesPoster },
  ],
  stationeryDesignPortfolio: [
    { img: ImageHelper.Other1 },
    { img: ImageHelper.Other2 },
    { img: ImageHelper.Other10 },
    { img: ImageHelper.Other12 },
  ],
};

export default PortfolioImagesData;
